import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-vision-statement',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './vision-statement.component.html',
  styleUrl: './vision-statement.component.scss',
})
export class VisionStatementComponent {}



